export default __webpack_public_path__ + "static/media/Version (4) - Half-Blood Prince_18.c48255cb.jpg";